import { createApiInstance } from "../../foundation/api";

const timeout = JSON.parse(process.env.REACT_APP_ECOMM_TIMEOUT_SEC) * 1000;

const client = createApiInstance(process.env.REACT_APP_ECOMM_URL, false, {
  timeout,
});
const authClient = createApiInstance(process.env.REACT_APP_ECOMM_URL, true, {
  timeout,
});
const clientWithLoader = createApiInstance(
  process.env.REACT_APP_ECOMM_URL,
  false,
  { timeout },
  true
);
const authClientWithLoader = createApiInstance(
  process.env.REACT_APP_ECOMM_URL,
  true,
  { timeout },
  true
);

export { client, authClient, clientWithLoader, authClientWithLoader };
